import Col from "react-bootstrap/Col";
import React from "react";
import {Placeholder} from "react-bootstrap";
import styled from "styled-components";

import {getTheme} from "../../../shared/themeUtils";

const Element = styled.div`
  list-style: none;
  border-bottom: 1px solid ${getTheme("colors.border")};
  margin-right: ${getTheme("space.2")};
  padding: ${getTheme("space.2")} ${getTheme("space.1")};
  font-size: ${getTheme("fontSizes.medium")};
  display: flex;
  font-weight: 500;
  cursor: pointer;

  .image-contain {
    margin-right: ${getTheme("space.1")};
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 60px;
    height: 60px;
  }
`

const MenuSubcategoryPlaceholder = () => {
  return (
    <Element>
      <Col xs="2" className="image-contain placeholder">
      </Col>
      <Col className="text-contain">
        <Placeholder xs={6} /> <Placeholder xs={8} />
      </Col>
    </Element>
  )
}

export default MenuSubcategoryPlaceholder